import styled from 'styled-components';

export const LabelContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  margin: 4px;
  padding: 4px;
  align-items: center;
  font-size: smaller;
`;
  
export const LabelText = styled.span`
  margin-left: 4px;
  margin-right: 2px;
`;